import { render, staticRenderFns } from "./CallTimeChartsList.vue?vue&type=template&id=681a8b12&scoped=true&"
import script from "./CallTimeChartsList.vue?vue&type=script&lang=js&"
export * from "./CallTimeChartsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a8b12",
  null
  
)

export default component.exports